export default __webpack_public_path__ + "static/media/tope.cfce992d.png";